<template>
  <v-form class="form" ref="form" v-model="valid" lazy-validation>
    <div class="mt-5 mb-5">
      <h3>Então bora calcular...</h3>
    </div>
    <div>
      <v-select
        v-model="diet"
        item-value="diet"
        :items="diets"
        item-text="diet.title"
        :rules="[v => !!v || 'É necessário selecionar a dieta']"
        label="Dieta referência"
        required
      ></v-select>
    </div>

    <div>
      <v-text-field
        type="number"
        required
        :rules="rules"
        v-model.trim="patient.body"
        label="Massa corporal"
      ></v-text-field>
      <v-text-field
        type="number"
        required
        :rules="rules"
        v-model="patient.cal"
        label="Meta calórica (kcal/kg)"
      ></v-text-field>
      <v-text-field
        type="number"
        required
        :rules="rules"
        v-model="patient.protein"
        label="Meta proteica (gPTN/kg)"
      ></v-text-field>
      <v-text-field
        type="number"
        required
        :rules="rules"
        v-model="patient.volume"
        label="Volume recebido (mL)"
      ></v-text-field>
      <v-checkbox
        v-model="saveData"
        label="Podemos salvar esses dados? Assim poderá vê-los no futuro, caso precise"
      ></v-checkbox>
      <div v-if="saveData">
        <v-text-field
          required
          :rules="nameRules"
          v-model.trim="patient.name"
          :counter="10"
          label="Nome do paciente"
        ></v-text-field>
        <v-text-field
          required
          :rules="nameRules"
          v-model.trim="patient.lastName"
          :counter="10"
          label="Sobrenome do paciente"
        ></v-text-field>
      </div>
    </div>
    <div class="saveData mb-5">
      <div class="saveData-send">
        <v-btn :disabled="!valid" color="success" @click="calcDiet(), dialog = true">Calcular!!</v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="500">
      <app-results v-if="dialog" :toCalculate="toCalculate"></app-results>
    </v-dialog>
  </v-form>
</template>

<script>
export default {
  name: "appForm",
  data: () => ({
    dialog: false,
    toCalculate: {},
    patient: {
      name: "",
      lastName: "",
      body: "",
      cal: "",
      protein: "",
      volume: ""
    },
    diet: null,
    nameRules: [
      v => !!v || "Campo é obrigatório",
      v => (v && v.length <= 10) || "Não pode passar de 10 caracteres"
    ],
    rules: [v => !!v || "Campo obrigatório"],
    valid: true,
    lazy: false,
    saveData: false
  }),
  computed: {
    diets() {
      return this.$store.getters["dietsBase/getDiets"];
    }
  },
  methods: {
    calcDiet() {
      this.toCalculate.patient = this.patient;
      this.toCalculate.diet = this.diet;
      this.toCalculate.saveData = this.saveData;
    }
  },
  watch: {
    dialog() {
      this.dialog == false ? this.$refs.form.reset() : this.dialog;
    }
  },
  components: {
    AppResults: () => import("./Results")
  }
};
</script>

<style scoped>
.form {
  max-width: 500px;
  align-self: center;
}
.fa-chevron-circle-right,
.fa-chevron-circle-left {
  font-size: 40px;
  color: #006064;
}

.saveData {
  display: flex;
  flex-direction: column;
}

.saveData-send {
  display: flex;
  justify-content: space-around;
}
</style>
